import React from "react";
import {withNamespaces} from "react-i18next";

const DaliDeviceInfo = ({t, title, networkDeviceInfo, infoElements = []}) => {
    return (
        <div className="row">
            <div className="col-md-3">
                <h4>{t(title)}</h4>
                <h5 className='font-italic'>{networkDeviceInfo?.label}</h5>
            </div>

            <div className="col-md-9">
                <ul>
                    <li className="list-group-item">{t('type')} : <b>{ networkDeviceInfo?.deviceType.label }</b></li>
                    <li className="list-group-item">{t('ip-address')} : <b>{ networkDeviceInfo?.ipAddress }</b></li>
                    { infoElements.map((item, idx) => {
                        return (
                            <li key={idx} className="list-group-item">{t(item.key)} : <b>{ item.value }</b></li>
                        )
                    }) }
                </ul>
            </div>
        </div>
    )
};
export default withNamespaces()(DaliDeviceInfo);
